import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';

export default {
  attributeName: 'room',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  // editURL: routes.SPORT_ROOM,
  isSelectable:true,
  emptyMessage: "You don't have categories, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Name of the app.',
    },
  ],
};
